import { createRouter, createWebHashHistory} from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Puntate from '../views/Puntate.vue'
import Episodio from '../views/Episodi/Episodio.vue'
import Oscars from '../views/Oscars.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/puntate',
    name: 'Puntate',
    component: Puntate
  },
  {
    path: '/episodi/:id',
    name: 'Episodio',
    component: Episodio, 
    // vuoldire che possiamo accettare i route-parms come prop
    props: true
  },
  {
    path: '/oscars',
    name: 'Oscars',
    component: Oscars, 
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
